<!-- page-content-section -->
<div class="related-products-container border-radius ">
  <fieldset>
    <!-- <legend>Related Products</legend> -->
    <!-- <input
      type="text"
      nz-input
      placeholder="Search for products..."
      ngModel
      (ngModelChange)="onSearch($event)"
      style="margin-bottom: 10px"
    /> -->
<!--  [disabled]="setOfCheckedIds.size ===0" --> 

    <div class="buttons" *ngIf="typeLabel !='Smart'">
      <a nz-button href="javascript:void(0)" (click)="showRecordsModal();"
       style="margin-right: 8px;">{{'Add Products' | translate}}</a>

           <button nz-button nzType="primary" nzDanger
      (click)="bullkDelete()" 
       
        >{{'Delete' | translate}}</button>
    </div>
    <nz-table
      [nzData]="products"
      [nzLoading]="isLoading"
      [nzShowPagination]="true"
      [nzShowSizeChanger]="true"
      [nzTotal]="baseProducts.length"
      [nzPageIndex]="tableParams.index"
      [nzPageSize]="tableParams.size"
    
      #productsTable
    >
      <thead>
        <tr>
        <th id="th-selectable" [nzWidth]="'50px'" [nzLeft]="true" [nzSelections]="listOfSelection"
        [(nzChecked)]="checked" [nzIndeterminate]="indeterminate">
        </th>
 
          <th>{{ 'Sku' | locale }}</th>
          <th>{{ 'Name' | locale }}</th>
          <th *ngIf="typeLabel !='Smart'"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of productsTable.data">
       <td>
             <label nz-checkbox id="td-selectable"
         [nzChecked]="setOfCheckedIds.has(product.id!)"
    (nzCheckedChange)="selection(product.id)"
    style="margin: 15px"
    ></label>
        </td>
          
          <td>{{ product.sku }}</td>
          <td>{{ product.name }}</td>
          <td *ngIf="typeLabel !='Smart'">
            <button
              nz-button
              nzDanger
              (click)="removeProduct(product.id!)"
              class="border-radius"
              
            >
              {{'Delete' | translate}}
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </fieldset>

  <!-- <div class="buttons">
    <a nz-button href="javascript:void(0)" (click)="showRecordsModal();">Add Products</a>
  </div> -->
</div>

<ng-template #productsDrawerTemplate>
  <div>
    <app-products-table
      [products]="modalRecords"
      [payload]="productsPayload"
      [isLoading]="isLoading"
      [totalCount]="totalProductsCount"
      [selectable]="true"
      [listColumns]="listColumns"
      [withActions]="false"
      [setOfSelectedProducts]="tempSelectedProducts"
      (getProducts)="productsPayload = $event; getModalProducts()"
      (selectionChange)="onProductSelectionChange($event)"
      (headerFiltersChanged)="handleFiltersChanges($event)"
    >
    </app-products-table>
  </div>
</ng-template>
<ng-template #recordsDrawerFooter>
  <nz-space>
    <button nz-button nzType="primary" (click)="selectRows()" *nzSpaceItem>
      <span nz-icon nzType="plus-circle" nzTheme="outline"></span>
      {{'Submit' | translate}}
    </button>
    <button nz-button *nzSpaceItem (click)="cancelSelection()">{{'Cancel' | translate}}</button>
  </nz-space>
</ng-template>
